/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bronze_Clear_Fish_HumInputs */

const en_bronze_clear_fish_hum = /** @type {(inputs: Bronze_Clear_Fish_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rare`)
};

const de_bronze_clear_fish_hum = /** @type {(inputs: Bronze_Clear_Fish_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selten`)
};

/**
* | output |
* | --- |
* | "Rare" |
*
* @param {Bronze_Clear_Fish_HumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bronze_clear_fish_hum = /** @type {((inputs?: Bronze_Clear_Fish_HumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bronze_Clear_Fish_HumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bronze_clear_fish_hum(inputs)
	return de_bronze_clear_fish_hum(inputs)
});